import styled from 'styled-components';
import { devices } from '../../utilities/responsive';

export const VacancyItem = styled.li`
    max-width: 100%;
    background: var(--white);
    box-shadow: 0 1px 3px rgba(0, 0, 0, .15);
    padding: 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 24px;
    flex-wrap: wrap;

    a[role="button"] {
        background: linear-gradient(to right, #654AD2 0%, #2173CF 40%, #247CCC 49%, #36B1BD 100%);
        font-weight: 800 !important; 
        background-size: 120%;
        transition: background .3s ease-out;  

        &:hover {
            background-position: 100% 0;
        }
    }

    &:not(:last-child) {
        margin-bottom: 24px;
    }
`;

export const VacancyItemText = styled.div`
    max-width: 70%;

    h1 {
        @media ${devices.phoneLg} {
            font-size: 2.4rem;
            line-height: 3.2rem;
        } 
    }

    @media ${devices.phone} {
        max-width: 100%;

        p {
            margin: 16px 0;
        }
    } 
`;